import React from 'react'
import styles from "../../../styles/components/video.module.scss";
import { Box, Button, Tooltip, TooltipProps, styled, tooltipClasses } from '@mui/material'
import assest from '../../../json/assest'


const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 199,
        height: 94,
        fontSize: theme.typography.pxToRem(12),
        boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.25);',
        borderRadius: '10px 10px 0px 10px;',
        border: 'none',
        padding: '10px 12px',
        margin: '0px',
    },
}));

const VideoDetails = (props) => {
    const { videoURL = true } = props;

    return (
        <Box className='VideocommonBox'>
            <Box className={styles.ownerDetails}>
                <Box className={styles.commonHeading}>
                    <h4>Video Details <span>user version</span></h4>
                </Box>


                <Box className={styles.videoDetails}>
                    <Box className={styles.videoDetailsBox}>
                        <h5>Public Post URL</h5>
                        <Box className={styles.videoInput}>
                            <input type='text' placeholder='https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV' />
                            <Button><img src={assest.copyIcon} width={13} height={16} alt='' /></Button>
                        </Box>
                    </Box>

                    <Box className={styles.videoDetailsBox}>
                        <h5>Title </h5>
                        <p>Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away</p>
                    </Box>

                    <Box className={styles.videoDetailsBox}>
                        <h5>Description:</h5>
                        <p>Fusce eget lacus non turpis porttitor gravida sit amet quis tellus. Morbi tempus finibus elit in ultrices. Nunc sagittis purus nisl,
                            eu elementum risus faucibus vitae. Integmolestie, ex sit amet semd mauris odimolestie, met semd mauris odimolestie, ex sit amet semd maurier
                            molestie, ex sit amet semd mauris odidgfgo...</p>
                        <Button className={styles.expandButton}><img src={assest.expandParaIcon} width={14} height={14} alt='' /></Button>
                    </Box>

                    <Box className={styles.videoDetailsBoxLocation}>
                        <Box className={styles.videoDetailsBox}>
                            <h5>Filming Location </h5>
                            <p>Los Angeles, California, United States</p>
                        </Box>

                        <Box className={styles.videoDetailsBox}>
                            <h5>Filming Date </h5>
                            <p>January 25, 2019</p>
                        </Box>
                    </Box>

                    {videoURL &&
                        <>
                            <Box className={styles.uploadURL}>
                                <Box className={styles.videoDetailsBox}>
                                    <h5>Website upload URL</h5>
                                    <Box className={styles.videoInput}>
                                        <input type='text' placeholder='https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV' />
                                        <Button><img src={assest.copyIcon} width={13} height={16} alt='' /></Button>
                                    </Box>
                                </Box>

                                <Box className={styles.videoDetailsBox}>
                                    <h5>YouTube upload URL</h5>
                                    <Box className={styles.videoInput}>
                                        <input type='text' placeholder='https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV' />
                                        <Button><img src={assest.copyIcon} width={13} height={16} alt='' /></Button>
                                    </Box>
                                </Box>

                                <Box className={styles.videoDetailsBox}>
                                    <h5>VS file link</h5>
                                    <Box className={styles.videoInput}>
                                        <input type='text' placeholder='https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV' />
                                        <Button><img src={assest.copyIcon} width={13} height={16} alt='' /></Button>
                                    </Box>
                                </Box>
                            </Box>

                            <Box className={styles.videoLink}>
                                <h5>Original Video File(s)</h5>
                                <Button><img src={assest.videoFileIcon} height={18} width={18} alt='' /> Add original video file (VS Link)</Button>

                                <Box className={styles.videoLinkBoxWrapper}>
                                    <Box className={styles.videoLinkBox}>
                                        <Box className={styles.inputBox}>
                                            <p>1.</p>
                                            <input type="text" placeholder='https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV' />
                                        </Box>

                                        <Box className={styles.linkIcon}>
                                            <Box className={styles.toolTipBox}>
                                                <HtmlTooltip placement="top-start" className='toolTip'
                                                    title={
                                                        <React.Fragment>
                                                            <Box className={styles.toolTipTxt}>
                                                                <h5>Added by:</h5>
                                                                <p>Partner/QC Agent/Member/Manager</p>
                                                            </Box>
                                                            <Box className={styles.toolTipTxt}>
                                                                <h5>Date:</h5>
                                                                <p>January 22, 2021 at 07:45 AM UTC</p>
                                                            </Box>
                                                        </React.Fragment>
                                                    }
                                                >
                                                    <Button><img src={assest.toolTipIcon} width={11} height={11} alt='' /></Button>
                                                </HtmlTooltip>
                                            </Box>
                                        </Box>
                                    </Box>

                                    <Box className={styles.videoLinkBox}>
                                        <Box className={styles.inputBox}>
                                            <p>2.</p>
                                            <input type="text" />
                                        </Box>

                                        <Box className={styles.linkIcon}>
                                            <Button><img src={assest.plusIconBlack} width={22} height={23} alt='' /></Button>
                                            <Box className={styles.crossAddicon}>
                                                <Button><img src={assest.rightIconBlack} width={22} height={23} alt='' /></Button>
                                                <Button><img src={assest.crossIconBlack} width={22} height={23} alt='' /></Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>

                            <Box className={styles.videoLink}>
                                <h5>Social Media Post(s)</h5>
                                <Button><img src={assest.socialMediaIcon} height={18} width={18} alt='' /> Add social media post URL</Button>

                                <Box className={styles.videoLinkBoxWrapper}>
                                    <Box className={styles.videoLinkBox}>
                                        <Box className={styles.inputBox}>
                                            <p>1.</p>
                                            <input type="text" placeholder='https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV' />
                                        </Box>

                                        <Box className={styles.linkIcon}>
                                            <Box className={styles.toolTipBox}>
                                                <HtmlTooltip placement="top-start" className='toolTip'
                                                    title={
                                                        <React.Fragment>
                                                            <Box className={styles.toolTipTxt}>
                                                                <h5>Added by:</h5>
                                                                <p>Partner/QC Agent/Member/Manager</p>
                                                            </Box>
                                                            <Box className={styles.toolTipTxt}>
                                                                <h5>Date:</h5>
                                                                <p>January 22, 2021 at 07:45 AM UTC</p>
                                                            </Box>
                                                        </React.Fragment>
                                                    }
                                                >
                                                    <Button><img src={assest.toolTipIcon} width={11} height={11} alt='' /></Button>
                                                </HtmlTooltip>
                                            </Box>
                                        </Box>
                                    </Box>

                                    <Box className={styles.videoLinkBox}>
                                        <Box className={styles.inputBox}>
                                            <p>2.</p>
                                            <input type="text" />
                                        </Box>

                                        <Box className={styles.linkIcon}>
                                            <Button><img src={assest.plusIconBlack} width={22} height={23} alt='' /></Button>
                                            <Box className={styles.crossAddicon}>
                                                <Button><img src={assest.rightIconBlack} width={22} height={23} alt='' /></Button>
                                                <Button><img src={assest.crossIconBlack} width={22} height={23} alt='' /></Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </>
                    }
                </Box>
            </Box>
        </Box>
    )
}

export default VideoDetails